import {
  fetchCategories,
  fetchCategory,
  fetchCategoryNewCourses,
  fetchCategoryPopularCourses,
  fetchCategoryLearningPaths,
} from '../../../models/categories'

const getCategories = async context => {
  try {
    const response = await fetchCategories()
    context.commit('CATEGORIES_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getCategory = async (context, id) => {
  try {
    const response = await fetchCategory(id)
    context.commit('CURRENT_CATEGORY_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getCategoryNewCourses = async (context, id) => {
  try {
    const response = await fetchCategoryNewCourses(id)
    context.commit('CATEGORY_NEW_COURSES_UPDATED', response.courses.data)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getCategoryPopularCourses = async (context, id) => {
  try {
    const response = await fetchCategoryPopularCourses(id)
    context.commit('CATEGORY_POPULAR_COURSES_UPDATED', response.courses.data)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

const getCategoryLearningPaths = async (context, id) => {
  try {
    const response = await fetchCategoryLearningPaths(id)
    context.commit('CATEGORY_LEARNING_PATHS_UPDATED', response)
  } catch (errorObj) {
    const { error } = errorObj
    const message =
      error && error.message ? error.message : 'Something went wrong'
    context.dispatch('app/setError', message, { root: true })
  }
}

export default {
  getCategories,
  getCategory,
  getCategoryNewCourses,
  getCategoryPopularCourses,
  getCategoryLearningPaths,
}
